import { RefObject, useEffect, useState } from 'react';

import { debounce } from 'src/utils/general.utils';
import { isMultilineTextTrimmed } from 'src/utils/screen.utils';

export const useTrimmedElementCheck = (
  elementRef: RefObject<HTMLElement | null>,
  elementHeightTolerance = 0,
) => {
  const [isTrimmed, setIsTrimmed] = useState(false);

  useEffect(() => {
    if (!elementRef.current) return;

    const element = elementRef.current;

    const observerCallback = debounce(() => {
      setIsTrimmed(isMultilineTextTrimmed(element, elementHeightTolerance));
    }, 100);

    const observer = new ResizeObserver(observerCallback);

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef.current, elementHeightTolerance]);

  return isTrimmed;
};
